import { Component, OnInit } from '@angular/core';
import { interplanReleaseDataServiceToUi, InterplanReleaseDateData, InterplanReleaseDateDataUi, MangeReleaseTableHeaderData } from '@data/interplanReleaseData/interplan-release-data';
import { InterplanReleaseDataService } from '@data/interplanReleaseData/interplan-release-data.service';
import { AdminNotificationService } from '@data/notification/admin-notification.service';
import { LoadPanelOption } from '@shared/common-components/load-panel/load-panel.component';
import { CommonDataService } from '@shared/services/common-data.service';
import { NotificationService } from '@shared/services/notification.service';
import { takeWhile } from 'rxjs/operators';

@Component({
    selector: 'app-manage-release-date',
    templateUrl: './manage-release-date.component.html',
    styleUrls: ['./manage-release-date.component.less'],
    standalone: false
})
export class ManageReleaseDateComponent implements OnInit {

  isAlive:boolean=true;
  loadingData:boolean=true;

  showLoadPanel=false;
  loadPanelOption:LoadPanelOption={
    closeOnOutsideClick:false,
    message:"loading...",
    visible:true,
    showPane:false,
    ofPosition:'#manageReleaseTable',
    shadingColor:'rgba(0,0,0,0.05)'
  };
  
  showUnviewedDataMsg:boolean=false;

  tableHeaderData = MangeReleaseTableHeaderData;

  interplanDataUi:InterplanReleaseDateDataUi;

  syncUsInProgressIdList:number[]=[];
  syncIntlInProgressIdList:number[]=[];
  disManageAdmin: boolean = false;

  constructor(private _int: InterplanReleaseDataService, private _adminNotify: AdminNotificationService, private commonServices: CommonDataService, private _notify:NotificationService) { 
    
    this._adminNotify.removeNotification(null, ['manageReleaseDate']);
    this._adminNotify.isAdminNotificationUpdated.next(true);

    const userData = this.commonServices.userData.value;
		const getSectionName = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Admin");
    const getSectionName1 = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Post-Production Admin");
    if(getSectionName[0].permissionName == "READ ONLY" || getSectionName1[0].permissionName == "READ ONLY"){
			this.disManageAdmin=true;
		}
    
    this.loadingData=true;
    this._int.isInterplanDataFetched.pipe(takeWhile(()=>this.isAlive)).subscribe(r=>{
      if(r){
        this.interplanDataUi= this._int.interplanReleaseDateDataUi;
        if(this.interplanDataUi?.data?.length)
          this.showUnviewedDataMsg = true;
        this.loadingData=false;
      }
      else{
        this.fetchInterplanData();
      }
    });
  }

  ngOnInit(): void{}

  fetchInterplanData(showLoading?:boolean){
    this.showLoadPanel=showLoading??false;
    this._int.getAllUnSynchedInterplanTitles().subscribe(
      r=>{
        if(r.status=='SUCCESS'){
          this._int.serviceResult = r.serviceResult??[];
          this._int.interplanReleaseDateDataUi = interplanReleaseDataServiceToUi(r.serviceResult??[]);
          this.interplanDataUi = this._int.interplanReleaseDateDataUi;
          if(this.interplanDataUi?.data?.length)
            this.showUnviewedDataMsg = true;
          this.showLoadPanel=false;
          this.loadingData=false;
        }
      }
    )
  }


  syncDate(opt:string, obj?:InterplanReleaseDateData){
    
    let data:any={
      psrInterplanDtos : [],
      syncType: opt
    }

    if(!obj){
      if(opt=='BOTH' || opt=='US')
        this.syncUsInProgressIdList =[];
      if(opt=='BOTH' || opt=='INTL')
        this.syncIntlInProgressIdList =[];

      for(let i of this.interplanDataUi.data){
        if(opt=='BOTH' || opt=='US')
          this.syncUsInProgressIdList.push(i.interplanReleaseDatesId);
        if(opt=='BOTH' || opt=='INTL')
          this.syncIntlInProgressIdList.push(i.interplanReleaseDatesId);
      }
      data.psrInterplanDtos = this._int.serviceResult;
    }
    else if(opt=='US' && obj){
      this.syncUsInProgressIdList.push(obj.interplanReleaseDatesId);
      data.psrInterplanDtos.push(this.getServiceResultObj(obj));
    }
    else if(opt=='INTL' && obj){
      this.syncIntlInProgressIdList.push(obj.interplanReleaseDatesId);
      data.psrInterplanDtos.push(this.getServiceResultObj(obj));
    }

    this._int.syncInterplanReleaseDateToPPSR(data).subscribe(
      r=>{
        if(r.status=="SUCCESS")
        {
          this.resetServiceResult(data.psrInterplanDtos,opt);
          this._int.interplanReleaseDateDataUi = interplanReleaseDataServiceToUi(this._int.serviceResult);
          this.interplanDataUi = this._int.interplanReleaseDateDataUi;
          this.resetSyncInProgressList(opt,obj);
        }
      }
    )
  }

  getServiceResultObj(obj:InterplanReleaseDateData){
    for(let s of this._int.serviceResult){
      if(s.interplanReleaseDatesId==obj.interplanReleaseDatesId){
        return s;
      }
    }
    return obj;
  }

  resetServiceResult(data:any,opt:string){

    for(let d of data){
      for(let s of this._int.serviceResult){
        if(s.interplanReleaseDatesId==d.interplanReleaseDatesId){
          if(opt=='BOTH' || opt=='US'){
            s.psrUSReleaseDate=s.interplanUSReleaseDate
          }
          if(opt=='BOTH' || opt=='INTL'){
            s.psrIntlReleaseDate=s.interplanIntlReleaseDate
          }
          break;
        }
      }
    }
  }


  resetSyncInProgressList(opt:string, obj?:InterplanReleaseDateData){
    if(!obj){
      if(opt=='BOTH' || opt=='US')
        this.syncUsInProgressIdList=[];
      if(opt=='BOTH' || opt=='INTL')
        this.syncIntlInProgressIdList=[];
      return;
    }

    let list:number[]=[];
    if(opt=='US'){
      for(let u of this.syncUsInProgressIdList){
        if(u!=obj.interplanReleaseDatesId)
          list.push(u);
      }
      this.syncUsInProgressIdList=list;
    }
    else if(opt=='INTL'){
      for(let i of this.syncIntlInProgressIdList){
        if(i!=obj.interplanReleaseDatesId)
          list.push(i);
      }
      this.syncIntlInProgressIdList=list;
    }

  }

  ngOnDestroy(){
    this._notify.removeErrorOnTabChange('manage-release-date');
  }

}
